<ul>
  <li
    *ngFor="let crumb of breadcrumbs; index as i"
    [ngClass]="whiteTheme ? 'whiteTheme' : ''"
  >
    <a
      id="breadcrumb-link-{{ i }}"
      [attr.data-cy]="'breadcrumb-' + (crumb.label | translate) + '-link'"
      *ngIf="!crumb.active; else active"
      [routerLink]="crumb.url"
      [ngClass]="whiteTheme ? 'whiteTheme' : ''"
      translate
      >{{ crumb.label }}</a
    >
    <ng-template #active>
      <span
        id="breadcrumb-link-active"
        data-cy="breadcrumb-active-link"
        [ngClass]="whiteTheme ? 'whiteTheme' : ''"
        translate
        >{{ crumb.label }}</span
      >
    </ng-template>
  </li>
</ul>
